module.exports = __webpack_public_path__ + "static/media/in-app-brand-placeholder.92270a8a.svg";